import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';


// Custom components
import DownloadData from '../DownloadData';
import NotificationsObjective from '../../../Settings/components/NotificationsObjective';
import NotificationsObjectiveList from '../../../Settings/components/NotificationsObjectiveList';
import Weighted from '../Weighted';
import EventsObjectives from '../EventsObjective';
import Measurements from '../Measurements';
import BaseElementsPlus from '../BaseElementsPlus'
import BaseRegistersPlus from '../BaseRegistersPlus';
//import Screenshots from '../Screenshots';
import Audios from '../Audios';
// DDIAZ FIX Momentaneo
import Screenshots from '../ScreenshotsRebuild';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';



// Palette
import palette from 'theme/palette';

// Component styles
import styles from './styles';


class SectionsTools extends Component {
    constructor(props) {
        super(props);
        //console.log("section", props)
        this.state = {
            downloadEl: null,
            listDisplayAlerts: [1,2,5],
            profileId: sessionStorage.getItem('profile_id'),
            alertsEl: null,
            value:0,
            listDisplayCreateAlerts: [1,5],
            updateDisabled: true,
            showPeriodEvent:false,
            weightedEl:null,
            eventsEl: null,
            measurementsEl: null,
            listPlus:[258,270,271,272,290,292],
            elePlus:null,
            regPlus: null,
            listScreenshot: [255,256,257,258,270,271,272,290,292,700],
            listIvr: [666],
            audiosEl: null,
        };
    }

    handleShowDownload = event => {
        this.setState({
            downloadEl: event.currentTarget
        });
    };
    handleCloseDownload = () => {
        this.setState({
            downloadEl: null
        });
    };

    handleShowAlerts = event => {
        this.setState({
            alertsEl: event.currentTarget
        });
    };
    handleCloseAlerts = () => {
        this.setState({
            alertsEl: null
        });
    };
    handleChangeUpdate = (newValues) => {
        //console.log(newValue)
        let newValue = 2
        this.setState({
            value: newValue,
            updateDisabled: false,
            alertobjectives: newValues
        });
    };

    handleShowPeriod = (event) => {   
        this.setState({
            showPeriodEvent: event.currentTarget,
        });
    };
    handleShowWeighted = event => {
        this.setState({
            weightedEl: event.currentTarget
        });
    };
    handleCloseWeighted = () => {
        this.setState({
            weightedEl: null
        });
    };

    handleShowEvents = event => {
        this.setState({
            eventsEl: event.currentTarget
        });
    };
    handleCloseEvents = () => {
        this.setState({
            eventsEl: null
        });
    };

    handleShowMeasurements = event => {
        this.setState({
            measurementsEl: event.currentTarget
        });
    };
    handleCloseMeasurements = () => {
        this.setState({
            measurementsEl: null
        });
    };

    handleShowElePlus = event => {
        this.setState({
            elePlus: event.currentTarget
        });
    };
    handleCloseElePlus = () => {
        this.setState({
            elePlus: null
        });
    };

    handleShowRegPlus = event => {
        this.setState({
            regPlus: event.currentTarget
        });
    };
    handleCloseRegPlus = () => {
        this.setState({
            regPlus: null
        });
    };

    handleShowScreenshots = event => {
        this.setState({
            screenshotsEl: event.currentTarget
        });
    };
    handleCloseScreenshots = () => {
        this.setState({
            screenshotsEl: null
        });
    };

    handleShowAudios = event => {
        this.setState({
            audiosEl: event.currentTarget
        });
    };
    handleCloseAudios = () => {
        this.setState({
            audiosEl: null
        });
    };
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };

    render() {

        const {downloadEl, listDisplayAlerts,updateDisabled, profileId, alertsEl, value, listDisplayCreateAlerts, alertobjectives,
            showPeriodEvent, weightedEl, eventsEl, measurementsEl, listPlus, elePlus, regPlus, listScreenshot, screenshotsEl, 
            audiosEl, listIvr, } =this.state
        const {classes, match, location}= this.props
        
        

        var displayAlerts = false
        var displayCreateAlerts = false
        var displayEle = false
        var displayScreenshot = false
        var displayAudios = false

        const showWeightedEl = Boolean(weightedEl);
        const showEventsEl = Boolean(eventsEl);
        const showMeasurementsEl = Boolean(measurementsEl);
        const showElePlus = Boolean(elePlus);
        const showRegPlus = Boolean(regPlus);
        const showDownloadEl = Boolean(downloadEl);
        const showAlertsEl = Boolean(alertsEl);
        const showScreenshotsEl = Boolean(screenshotsEl);
        const showAudiosEl = Boolean(audiosEl);

        if(listDisplayAlerts.includes(parseInt(profileId)) === true){
            displayAlerts = true
        }
        if(listDisplayCreateAlerts.includes(parseInt(profileId)) === true){
            displayCreateAlerts = true
        }
        if(listPlus.includes(location.state.fromObjective.servicio_id) === true){
            displayEle = true
        }

        if(listScreenshot.includes(location.state.fromObjective.servicio_id) === true){
            displayScreenshot = true
        }

        if(listIvr.includes(location.state.fromObjective.servicio_id) === true){
            displayAudios = true
        }
        return (
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{overflowY:'hidden'}}
            >
                <ExpansionPanel key={1} className={classes.backGrey} style={{margin: '0px'}}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.textWhite} />}>
                                <Typography className={classes.textWhite} variant="button" >Herramientas</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="left"
                        >
                            <Button onClick={this.handleShowDownload} className={classes.backGrey} variant="outlined" color="primary" size="small">
                                <Typography className={classes.textWhite} variant="button"> Descarga de Datos </Typography>
                            </Button>
                            {displayAlerts ? 
                                <Button className={classes.backGrey} onClick={this.handleShowAlerts} variant="outlined" color="primary" size="small">
                                    <Typography className={classes.textWhite} variant="button" > Configurar Alertas </Typography>
                                </Button>
                            : null}
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel key={2} className={classes.backGrey} style={{margin: '0px'}}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className={classes.textWhite}/>}>
                        <Typography className={classes.textWhite} variant="button">Secciones</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid
                            container
                            direction="column"
                            justifyContent="left"
                            alignItems="left"
                        >
                             <Button className={classes.backGrey} onClick={this.handleShowWeighted} variant="outlined" color="primary" size="small">
                                <Typography className={classes.textWhite} variant="button" > Ponderados </Typography>
                            </Button>
                            <Button className={classes.backGrey}  onClick={this.handleShowEvents} variant="outlined" color="primary" size="small">
                                <Typography className={classes.textWhite} variant="button"> Eventos </Typography>
                            </Button>
                            <Button className={classes.backGrey}  onClick={this.handleShowMeasurements} variant="outlined" color="primary" size="small">
                                <Typography className={classes.textWhite} nowrap variant="button"> Panel Dinámico de Consolidación de Mediciones </Typography>
                            </Button>
                            {displayEle===false? null:
                                <Button className={classes.backGrey}  onClick={this.handleShowElePlus} variant="outlined" color="primary" size="small">
                                    <Typography className={classes.textWhite} variant="button"> Elementos Plus </Typography>
                                </Button>
                                
                            }
                            {displayEle===false? null:
                                <Button className={classes.backGrey}  onClick={this.handleShowRegPlus} variant="outlined" color="primary" size="small">
                                    <Typography className={classes.textWhite} variant="button"> Registros Plus </Typography>
                                </Button>
                            }
                            {displayScreenshot === false? null:
                                <Button className={classes.backGrey}  onClick={this.handleShowScreenshots} variant="outlined" color="primary" size="small">
                                    <Typography className={classes.textWhite} variant="button"> Screenshots </Typography>
                                </Button>
                            }
                            {displayAudios === false? null:
                                <Button className={classes.backGrey}  onClick={this.handleShowAudios} variant="outlined" color="primary" size="small">
                                    <Typography className={classes.textWhite} variant="button"> Audios Ivr </Typography>
                                </Button>
                            }
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {/* PopOver Descarga de datos */}
                <Popover
                    anchorEl={downloadEl}

                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'left',
                        }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                    onClose={this.handleCloseDownload}
                    open={showDownloadEl}
                    >
                    <DownloadData params={this.props} onClose={this.handleCloseDownload} period="d"  typePeriod={1} typeGraph={6} title="Datos:" id="gauged-h" automaticUpdate={true} size="100%%" textSize="25" dataLabelsY="-35" />
                </Popover>
                {/* Modal Configurar Alertas */}
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showAlertsEl}
                    onClose={this.handleCloseAlerts}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showAlertsEl}>
                        <PerfectScrollbar style={{position:"static"}}>
                            <div className={classes.modalAlerts}> 
                            <AppBar position="static">
                            <Grid className={classes.buttonClosed} >
                                <IconButton className={classes.buttonClosedWhite} onClick={this.handleCloseAlerts}><CloseIcon/></IconButton>
                            </Grid>
                                <Tabs value={value} onChange={this.handleChange} aria-label="simple tabs example">
                                    <Tab label="Ver"  />
                                    <Tab label="Agregar" disabled={!displayCreateAlerts}/>
                                    <Tab label="Editar" disabled={updateDisabled}/>
                                </Tabs>
                            </AppBar>

                            { value == 0 ? 
                                <NotificationsObjectiveList params={this.props} onClick={this.handleChangeUpdate}/>   
                            : value == 1 ?
                                <NotificationsObjective value={value} alertobjectives={alertobjectives} objective={match.params.objetivo_id}/> 
                            : value == 2 ?
                                <NotificationsObjective value={value} alertobjectives={alertobjectives} objective={match.params.objetivo_id}/> 
                            : null}
                            </div>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>
                {/*Modal Ponderados */}     
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showWeightedEl}
                    onClose={this.handleCloseWeighted}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showWeightedEl}>
                        <PerfectScrollbar style={{position:"static"}}>
                        <Grid container direction="row" justify="space-evenly" alignItems="center" className={classes.modal}>                             
                            <Weighted  onClose={this.handleCloseWeighted} />
                        </Grid>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>              
                {/*Modal Eventos */}  
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showEventsEl}
                    onClose={this.handleCloseEvents}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showEventsEl}>
                        <PerfectScrollbar style={{position:"static"}}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center" className={classes.modal}>
                                <EventsObjectives params={this.props} onClose={this.handleCloseEvents} title="Eventos:" period="d" id="gauged-h" automaticUpdate={true} size="100%%" textSize="25" dataLabelsY="-35" />
                            </Grid>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>        
                {/*Panel Dinamico */} 
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showMeasurementsEl}
                    onClose={this.handleCloseMeasurements}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showMeasurementsEl}>
                        <PerfectScrollbar style={{position:"static"}}>
                        <div className={classes.modal}>                             
                            <Measurements params={this.props} onClose={this.handleCloseMeasurements} title="Tiempo de Respuesta y Disponibilidad por Isp" period="d" id="availability-h" typePeriod={1} typeGraph={6} automaticUpdate={true} size="90%" textSize="25" dataLabelsY="-35" />                      
                        </div>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>          
                {/*Ele Plus */} 
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showElePlus}
                    onClose={this.handleCloseElePlus}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        top:"100px"
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showElePlus}>
                        <PerfectScrollbar>
                        <div className={classes.modalEle}>
                            <BaseElementsPlus onClose={this.handleCloseElePlus}/>
                        </div>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>          
                {/*Registro Plus */} 
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showRegPlus}
                    onClose={this.handleCloseRegPlus}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        top:"100px"
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showRegPlus}>
                        <PerfectScrollbar>
                        <div className={classes.modalEle}>
                            <BaseRegistersPlus onClose={this.handleCloseRegPlus}/>
                        </div>
                        </PerfectScrollbar>
                </Fade>
                </Modal>      
                {/*Screenshots */} 
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showScreenshotsEl}
                    onClose={this.handleCloseScreenshots}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        top:"150px",
                        maxHeight: '70vh'
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showScreenshotsEl}>
                        <PerfectScrollbar>
                            <Screenshots onClose={this.handleCloseScreenshots}/>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>         
                {/*Audios */} 
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showAudiosEl}
                    onClose={this.handleCloseAudios}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        top:"100px"
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showAudiosEl}>
                        <PerfectScrollbar>
                        <div className={classes.modalEle}>
                            <Audios onClose={this.handleCloseAudios}/>
                        </div>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>           
            </Grid>
            
        )
    }
}


export default
    compose(withRouter, withStyles(styles))(SectionsTools);